import { render, staticRenderFns } from "./dictamen-emeritos.vue?vue&type=template&id=71a75869&scoped=true&"
import script from "./dictamen-emeritos.component.ts?vue&type=script&lang=ts&"
export * from "./dictamen-emeritos.component.ts?vue&type=script&lang=ts&"
import style0 from "./dictamen-emeritos.vue?vue&type=style&index=0&id=71a75869&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a75869",
  null
  
)

export default component.exports